import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, installLegacyShim, setDefaultParams, trackPage } from './analytics';

/**
 * Mounted once inside the router: starts analytics and reports each page by its route template. Who is counted is worked out
 * by the gateway from the session (a daily hash), so nothing about the user is handled here. Renders nothing.
 */
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    installLegacyShim();
    // Every event says it comes from the web app; the sandbox gateway sends the same events for Claude Code and Claude apps.
    setDefaultParams({ surface: 'web' });
    initAnalytics();
  }, []);

  useEffect(() => {
    trackPage(location.pathname);
  }, [location.pathname]);

  return null;
};

export default AnalyticsTracker;
